import React, { useState } from 'react'
import { IToast } from '../../../../interfaces/components/IToast';
import RunEmailsToCheck from '../details/RunEmailsToCheck';
import DiscrepancyModal from '../modals/DiscrepancyModal';
import UploadFilesModal from '../modals/UploadFilesModal';
import Button from '../../../../shared/button';
import Toast from '../../../../shared/toast';

const CreditTab = () => {
    const [showToast, setShowToast] = useState<IToast | null>()
    const [showFilesModal, setShowFilesModal] = useState<boolean>()
    const [response, setResponse] = useState<any>();

    const onOpenFilesModal = () => {
        setShowFilesModal(true)
    }

    const onCloseModal = () => {
        setShowFilesModal(false)
        setResponse(undefined)
    }

    return (
        <div>
            <div className='my-10 flex flex-col md:flex-row justify-center'>
                <Button
                    label={'Upload Files For Credit To Compare'}
                    className='btn-primary-rounded-less mr-4 mb-5 md:mb-0'
                    onClickButton={onOpenFilesModal}
                />
                <RunEmailsToCheck
                    setResponse={setResponse}
                />
            </div>
            {showFilesModal &&
                <UploadFilesModal
                    openModal={showFilesModal}
                    type={'credit'}
                    handleCloseModal={onCloseModal}
                />
            }
            {response &&
                <DiscrepancyModal
                    openModal={!!response}
                    data={response}
                    handleCloseModal={onCloseModal}
                />
            }
            {showToast?.message &&
                <Toast
                    type={showToast?.type}
                    text={showToast?.message}
                    onHandleCloseToast={() => setShowToast(null)}
                />
            }
        </div>
    )
}
export default CreditTab;